import { getLang } from '@/js/utils/I18n';
import { Locale } from 'date-fns';
// eslint-disable-next-line import/extensions
import { cs, sk, enGB, de, ro, bg, hu, pl, sl } from 'date-fns/locale';

export const getDateFnsLocale = (): Locale => {
    switch (getLang()) {
        case 'en':
            return enGB;
        case 'de':
            return de;
        case 'ro':
            return ro;
        case 'bg':
            return bg;
        case 'hu':
            return hu;
        case 'pl':
            return pl;
        case 'sk':
            return sk;
        case 'sl':
            return sl;
        case 'cs':
        default:
            return cs;
    }
};
